module.exports = __webpack_public_path__ + "img/sv68on.cf704878.svg";